import { useParams } from 'react-router-dom';

import { useDashboards } from '@/hooks/useSwr';

import { Breadcrumb, BreadcrumbData } from '../../components/Breadcrumbs';

export function SingleDashboardCrumb(props: Partial<BreadcrumbData>) {
  const { dashboardId } = useParams();
  const { data: sections } = useDashboards({
    limit: 10,
    offset: 0,
    ids: dashboardId ? [dashboardId] : undefined,
  });

  if (sections && sections.length) {
    return <Breadcrumb name={sections[0].title} {...props} />;
  }
  return <Breadcrumb name="Chart" {...props} />;
}
